module.exports = __webpack_public_path__ + "static/media/ShirbitLogo.b0a1c23b.png";